<div class="dialog-header">
  <h2 class="title">Contrato de Adesão</h2>
</div>

<mat-dialog-content class="content">
  <article class="contract">
    <h1>CONTRATO DE ADESÃO PARA UTILIZAÇÃO DE SITE DE COMPRA E VENDA DE INGRESSOS ONLINE</h1>

    <p>
      Pelo presente instrumento particular de contrato de adesão, de um lado,
      <strong>YES 7 TICKETS LTDA (YES7 TICKETS)</strong>, pessoa jurídica de direito privado, inscrita no CNPJ sob o nº
      <strong>54.728.36/0001-06</strong>, com sede na Rua Cerejeira, nº 64, Bairro KLP, CEP 85868-050, na cidade de Foz
      do Iguaçu-PR, doravante denominada simplesmente "<strong>CONTRATANTE</strong>", neste ato representada por
      <strong>JUNIOMAR FERNANDO PEDROSO</strong>, brasileiro, casado, empresário, portador da Cédula de Identidade Civil
      nº 720233-4, inscrito no CPF sob o nº 006.041.159-70, residente e domiciliado na Rua Cerejeira, nº 64, Jardim
      Laranjeiras, na cidade de Foz do Iguaçu – Paraná; e de outro lado, a pessoa física ou jurídica que venha a aderir
      ao presente contrato por meio de cadastro e aceitação eletrônica no site da CONTRATANTE, doravante denominada
      simplesmente "<strong>USUÁRIO</strong>", resolvem celebrar o presente contrato de adesão mediante as seguintes
      cláusulas e condições:
    </p>

    <h2>CLÁUSULA PRIMEIRA – DO OBJETO</h2>
    <p>
      O presente contrato tem por objeto a disponibilização, pela CONTRATANTE, de uma plataforma online para a compra e
      venda de ingressos para eventos diversos, mediante as regras e condições estabelecidas neste instrumento.
    </p>

    <h2>CLÁUSULA SEGUNDA – DO CADASTRO</h2>
    <p>
      <strong>2.1.</strong> Para utilizar a plataforma, o USUÁRIO deverá realizar cadastro prévio, informando dados
      pessoais e/ou empresariais verídicos e atualizados.
    </p>
    <p>
      <strong>2.2.</strong> O USUÁRIO declara estar ciente de que a veracidade das informações fornecidas é de sua
      exclusiva responsabilidade.
    </p>

    <h2>CLÁUSULA TERCEIRA – DAS RESPONSABILIDADES DAS PARTES</h2>
    <p><strong>3.1. Da CONTRATANTE:</strong></p>
    <ul>
      <li>Disponibilizar uma plataforma segura e funcional para compra e venda de ingressos;</li>
      <li>Garantir suporte técnico em caso de problemas na utilização da plataforma.</li>
    </ul>
    <p><strong>3.2. Do USUÁRIO:</strong></p>
    <ul>
      <li>Utilizar a plataforma de forma lícita e respeitando os termos deste contrato;</li>
      <li>Manter a confidencialidade de seus dados de acesso;</li>
      <li>Responder integralmente pela veracidade das informações inseridas na plataforma.</li>
    </ul>

    <h2>CLÁUSULA QUARTA – DAS TRANSAÇÕES FINANCEIRAS</h2>
    <p>
      <strong>4.1.</strong> A comercialização de ingressos é realizada diretamente entre o USUÁRIO e terceiros
      vendedores, cabendo à CONTRATANTE apenas intermediar a transação.
    </p>
    <p>
      <strong>4.2.</strong> As taxas e comissões aplicáveis serão previamente informadas ao USUÁRIO antes da conclusão
      de cada transação.
    </p>
    <p>
      <strong>4.3.</strong> O processamento de pagamentos será realizado por meio de parceiros financeiros autorizados.
    </p>

    <h2>CLÁUSULA QUINTA – DA PROTEÇÃO DE DADOS</h2>
    <p>
      <strong>5.1.</strong> A CONTRATANTE se compromete a proteger os dados pessoais do USUÁRIO, nos termos da
      legislação vigente, incluindo a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/2018).
    </p>
    <p>
      <strong>5.2.</strong> Os dados serão utilizados apenas para fins relacionados à execução deste contrato e à
      melhoria dos serviços prestados.
    </p>

    <h2>CLÁUSULA SEXTA – DAS PENALIDADES</h2>
    <p>
      <strong>6.1.</strong> O uso indevido da plataforma sujeitará o USUÁRIO às penalidades previstas em lei, além do
      bloqueio ou exclusão de sua conta.
    </p>

    <h2>CLÁUSULA SÉTIMA – DA VIGÊNCIA E RESCISÃO</h2>
    <p>
      <strong>7.1.</strong> O presente contrato entra em vigor na data de aceitação eletrônica pelo USUÁRIO e vigorará
      por prazo indeterminado.
    </p>
    <p>
      <strong>7.2.</strong> O contrato poderá ser rescindido a qualquer momento por ambas as partes, mediante
      comunicação prévia por meio da plataforma.
    </p>

    <h2>CLÁUSULA OITAVA – DIREITO DE ARREPENDIMENTO E REEMBOLSO PELO CONSUMIDOR</h2>
    <p>
      <strong>8.1</strong> Nos termos do artigo 49 do Código de Defesa do Consumidor (Lei nº 8.078/1990), o usuário
      poderá exercer o direito de arrependimento no prazo de até 7 (sete) dias corridos contados da data da compra do
      ingresso, desde que o pedido seja realizado antes da realização do evento e com prazo hábil para o cancelamento da
      transação.
    </p>

    <h2>CLÁUSULA NONA – ALTERAÇÃO DO EVENTO E RESPONSABILIDADE DO PRODUTOR</h2>
    <p>
      <strong>9.1</strong> Caso o evento adquirido pelo usuário seja alterado em data, horário, local ou condições
      relevantes, sendo tal alteração de responsabilidade exclusiva do produtor do evento, o usuário poderá requerer o
      reembolso integral do valor pago em até 30 (trinta) dias corridos após a comunicação da alteração pela plataforma.
      A solicitação deverá ser realizada por meio dos canais oficiais indicados na plataforma.
    </p>
    <p>
      <strong>§1º.</strong> A responsabilidade pelo reembolso será do produtor do evento, conforme previsto na
      legislação vigente e nos termos acordados entre a plataforma e o produtor.
    </p>
    <p>
      <strong>§2º.</strong> Caso o usuário opte por não solicitar o reembolso dentro do prazo estipulado, ele poderá
      revender o ingresso a terceiros por meio da própria plataforma, utilizando as ferramentas disponibilizadas para
      esse fim, respeitadas as condições e prazos estabelecidos.
    </p>

    <h2>CLÁUSULA DÉCIMA – TAXAS DE SERVIÇO E PROCESSAMENTO</h2>
    <p>
      <strong>10.1</strong> Pela utilização da plataforma, será cobrada uma taxa de processamento correspondente a 3,5%
      (três vírgula cinco por cento) do valor total do ingresso, incidente sobre cada transação realizada. Essa taxa
      visa cobrir custos operacionais, de tecnologia e de meios de pagamento e será destacada ao usuário no momento da
      finalização da compra.
    </p>

    <h2>CLÁUSULA DÉCIMA-A – DA TAXA DE SERVIÇO PELA UTILIZAÇÃO DA PLATAFORMA</h2>
    <p>
      <strong>10.A-1</strong> Pela utilização da plataforma disponibilizada pela CONTRATANTE, será cobrada uma taxa de
      serviço no percentual de _% (por cento) sobre o valor total do ingresso. O USUÁRIO declara ter plena ciência desta
      cobrança, a qual será informada de forma destacada no momento da contratação, e consente livremente com o
      respectivo pagamento, como condição para a efetivação da compra ou venda de ingresso por meio da plataforma.
    </p>

    <h2>CLÁUSULA DÉCIMA PRIMEIRA – DAS DISPOSIÇÕES GERAIS</h2>
    <p>
      <strong>11.1.</strong> A tolerância a eventual descumprimento de quaisquer cláusulas deste contrato não importará
      em renúncia de direitos.
    </p>
    <p>
      <strong>11.2.</strong> O presente contrato poderá ser atualizado unilateralmente pela CONTRATANTE, mediante
      comunicação prévia ao USUÁRIO.
    </p>

    <h2>CLÁUSULA DÉCIMA SEGUNDA – DO FORO</h2>
    <p>
      <strong>12.1.</strong> As partes elegem o foro da Comarca de Foz do Iguaçu-PR para dirimir quaisquer controvérsias
      oriundas deste contrato, com renúncia expressa a qualquer outro, por mais privilegiado
    </p>

    <p style="margin-top: 2rem">
      <strong>YES 7 TICKETS LTDA</strong><br />
      <strong>JUNIOMAR FERNANDO</strong><br />
      PEDROSO<br />
      Representante Legal
    </p>
  </article>
</mat-dialog-content>

<mat-dialog-actions align="end" class="footer-actions">
  <button mat-flat-button color="primary" (click)="close()">Fechar</button>
</mat-dialog-actions>
